import { Browser } from '@capacitor/browser';

export async function openExternalUrl(url: string): Promise<void> {
  await Browser.open({ url });
}
